import script from "./ManageBuilding.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageBuilding.vue?vue&type=script&setup=true&lang=ts"

import "./ManageBuilding.vue?vue&type=style&index=0&id=6ae88281&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae88281"]])

export default __exports__